









import { Component, Vue } from "vue-property-decorator";

@Component
export default class FooterBar extends Vue {
  version = "v" + process.env.VUE_APP_VERSION;

  get bp(): string {
    return this.$vuetify.breakpoint.name;
  }
}
